export default __webpack_public_path__ + "static/media/tele.d5d7605d.png";